import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

import StreamCard from '../StreamCard'
import NewWindow from '../../../utils/NewWindow'
import defaultImage from '../../../assets/images/TestBanner.png'

const styles = theme => ({
  cardsContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap'
  }
})

const MyEvents = ({ classes, isLoading, streams, fetchPaidStreams }) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (streams === undefined) {
      fetchPaidStreams()
    }
  })

  const [startStream, setStartStream] = useState(false)

  return (
    <>
      {/* Container for current user's streams */}
      <div className={classes.cardsContainer}>
        {
          // checking streams exist
          streams && streams.map(stream => (
            <StreamCard key={stream.id}
              image={defaultImage}
              title={stream.title}
              descr={stream.description}
              price={'$100 USD'}
              startDate={stream.startDate}
              actionLabel={t('Cabinet:watch stream')}
              onStartStream={() => setStartStream(true)} />
          ))
        }
      </div>

      {startStream && (<NewWindow url={'/webcam'} onUnload={() => setStartStream(false)}/>)}
    </>
  )
}

export default withStyles(styles)(MyEvents)
